export default __webpack_public_path__ + "assets/images/196e3de80db2aa24fe71c99c3cdf4a0f.svg";